import React from 'react';

// App-wide safety net: any uncaught render/effect error shows a recovery screen
// instead of a blank white page (React unmounts the whole tree on an uncaught
// error).
//
// 🔴 XATO ENDI JIMGINA YO'QOLMAYDI. Ilgari bu ekran "Sessiya tugagan bo'lishi
// mumkin, qayta kiring" derdi — bu KO'P HOLDA YOLG'ON edi (jonli misol: agent
// sinovi natijasida obyekt render qilinib daraxt uzilgan, sessiya esa joyida).
// Foydalanuvchi qayta kirardi, xato esa hech kimga yetib bormasdi. Endi:
//   1) xato AVTOMATIK backendga yuboriladi (POST /ui-error → 💥 Crashlar + Telegram),
//   2) ekran halol gapiradi: "qayd etildi, ustida ishlanmoqda",
//   3) asosiy amal — sahifani YANGILASH (render xatosi uchun to'g'ri chora),
//      "Qayta kirish" esa ikkilamchi (sessiya haqiqatan tugagan holat uchun).
const API = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, reported: null, message: '' };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, message: (error && error.message) || 'Nomsiz xato' };
  }
  componentDidCatch(error, info) {
    console.error('App crashed (ErrorBoundary):', error, info);
    this.report(error, info);
  }
  // Hisobot HECH QACHON throw qilmasligi kerak — aks holda tiklash ekrani ham yiqiladi.
  async report(error, info) {
    try {
      let userRef = null;
      try {
        const u = JSON.parse(localStorage.getItem('khorezmai_user') || 'null');
        if (u && u.id) userRef = `${u.id}:${u.username || ''}`.slice(0, 60);
      } catch (e) {}
      const res = await fetch(`${API}/ui-error`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: (error && error.message) || String(error),
          stack: (error && error.stack) || '',
          componentStack: (info && info.componentStack) || '',
          url: window.location.pathname + window.location.hash,
          userAgent: navigator.userAgent,
          userRef,
        }),
      });
      const d = await res.json().catch(() => ({}));
      this.setState({ reported: res.ok && d && d.ok ? 'ok' : 'fail' });
    } catch (e) {
      this.setState({ reported: 'fail' });
    }
  }
  handleReload = () => { window.location.reload(); };
  handleReLogin = () => {
    try {
      localStorage.removeItem('khorezmai_token');
      localStorage.removeItem('khorezmai_user');
    } catch (e) {}
    window.location.replace('/login');
  };
  render() {
    if (this.state.hasError) {
      const { reported, message } = this.state;
      const status = reported === 'ok'
        ? '✅ Xato avtomatik qayd etildi — biz ustida ishlaymiz.'
        : reported === 'fail'
          ? '⚠️ Xatoni serverga yuborib bo‘lmadi (internet?). Iltimos, skrinshot bilan xabar bering.'
          : '⏳ Xato qayd etilmoqda…';
      return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f172a', color: '#f1f5f9', fontFamily: 'system-ui, sans-serif', padding: 24, textAlign: 'center' }}>
          <div style={{ maxWidth: 460 }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>⚡</div>
            <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>Nimadir xato ketdi</div>
            <div style={{ color: '#94a3b8', marginBottom: 12, lineHeight: 1.5 }}>
              Bu sahifani ko‘rsatishda kutilmagan xato yuz berdi. Ma’lumotlaringiz joyida —
              sahifani yangilash odatda yetarli.
            </div>
            <div style={{ color: reported === 'fail' ? '#fbbf24' : '#6ee7b7', fontSize: 13, marginBottom: 20 }}>
              {status}
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
              <button onClick={this.handleReload} style={{ background: '#4f46e5', color: '#fff', border: 'none', borderRadius: 12, padding: '12px 24px', fontSize: 16, fontWeight: 600, cursor: 'pointer' }}>
                Sahifani yangilash
              </button>
              <button onClick={this.handleReLogin} style={{ background: 'transparent', color: '#94a3b8', border: '1px solid #334155', borderRadius: 12, padding: '12px 20px', fontSize: 15, cursor: 'pointer' }}>
                Qayta kirish
              </button>
            </div>
            {message && (
              <details style={{ marginTop: 18, color: '#64748b', fontSize: 12, textAlign: 'left' }}>
                <summary style={{ cursor: 'pointer' }}>Texnik tafsilot</summary>
                <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', marginTop: 8 }}>{message}</pre>
              </details>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
